export function typeToConverterSet(converterSets) {
    return converterSets.reduce((result, converterSet) => {
        const types = converterSet.types.reduce((typeResult, type) => {
            return {
                ...typeResult,
                [type]: converterSet,
            };
        }, {});
        return {
            ...result,
            ...types,
        };
    }, {});
}
//# sourceMappingURL=utils.js.map